<style>
.popover{
  max-width: 500px!important;
}
</style>
<script>
import {  mapGetters } from "vuex"; 
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Vue from 'vue';
import { notify } from '@/helpers/notify' 
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Survey from './modals/survey_modal.vue'

export default {
    page: {
        title: "Müşteri Memnuniyeti",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader,
        Survey
    },
    computed: {
        ...mapGetters('authfack',['userdata'])
    },
    data() {
        return {
            title: "Müşteri Memnuniyeti",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "MÜŞTERİ MEMNUNİYETİ",
                    active: true,
                },
            ], 
            searchParams: {},
            columns: [
                    { name: 'İsim Soyisim', key: 'fullname',  width: "50%" },
                    { name: 'Telefon Numarası', key: 'phonenumber',  width: "20%" },
                    { name: 'Kurulduğu Tarih', key: 'done_at',  width: "20%" },
                    { name: 'Durum', key: 'status', width: 50 },
            ],
            tableData: {
            detail: false,
            excel: true,
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            endpoint: '/members/surveys',
            modelOpen:0,
            subsId:{},
        };
    },

  methods: {
    async loadPage() {
        this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
        
        const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
        if (this.params.page === 1) {
            this.tableData.data = response.data.data;
        } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
        }
    
        this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false

        this.lastUpdated = new Date().toLocaleTimeString();
    },
    
    popoverContent(histories) {
      const listItems = histories.map(history => {
        return `
          <li>${history.description}</li>
        `;
      }).join('');

      return `<ul>${listItems}</ul>`;
    },
    
    cevapver(props){
      if(props.status == 'kabuletti') return

       this.modelOpen +=1
       this.subsId = { id: props.subs_id } 
       this.$parent.$bvModal.show('survey_modal')
    },

    date(obj){
        return this.formatDate(obj, "DD.MM.YYYY HH:mm")
    },

    sil(props){
      Vue.swal({
          title: "Ticket Kapanacak ?",
          showCancelButton: true,
          cancelButtonText: "Vazgeç",
          confirmButtonText: "Kapat"
      }).then((result) => {
          if (result.value) {
            this.$http.put('/tickets/' + props.id)
            .then(response => {
                if(response.data.code == 100){
                  this.loadPage()
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });
    },
    setRefresh() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      const converTime = (this.preferred.interval * 60) * 1000
      this.intervalId = setInterval(this.loadPage, converTime);
    },
    filter(column){
        this.searchParams = { column }
        this.loadPage()
    },
    searchQuerys(){
        if(this.searchQuery.length > 0 && this.searchQuery.length < 3) return
        this.loadPage()
    }
   }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

     <Survey 
      :modelOpen="modelOpen" 
      :data="subsId"
      @loadItems="loadPage"
     />
      
   
    <div class="row mt-2"> 
      <div class="col-12">
        <div class="card mb-0">
            <div class="card-body">
                <div class="table-responsive" style="min-height: 300px;">
                    <table class="table table-hover">
                        <thead class="table-head" >
                            <tr>
                                <th style="width:2%"></th>
                                <th :style="`width:${column.width}`" v-for="(column,i) in columns"  :key="i">{{ column.name }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in tableData.data" :key="rowIndex" @click="cevapver(row)">
                                <th>{{ rowIndex+=1 }}</th>
                                <td v-for="(column, colIndex) in columns" :key="colIndex">
                                    <template v-if="column.key == 'fullname'">{{  row.fname }} {{  row.lname }} </template>
                                    <template v-else-if="column.key == 'created_at'"> {{ date(row.created_at) }} </template>
                                    <template v-else-if="column.key == 'done_at'"> {{ date(row.done_at) }} </template>
                                    <template v-else-if="column.key == 'status'">
                                        <span class="me-1 badge bg-success rounded-pill" v-if="row.status == 'kabuletti'">Anket Yapıldı</span>
                                        <span class="me-1 badge bg-info rounded-pill" v-else-if="row.status == 'ulasilamadi'">Müşteriye Ulaşılamadı</span>
                                        <span class="me-1 badge bg-danger rounded-pill" v-else-if="row.status == 'reddetti'">Müşteriye Ulaşılamadı</span>
                                        <span class="me-1 badge bg-warning rounded-pill" v-else>Anket Yapılmadı</span>
                                    </template>
                                    <template v-else>{{ row[column.key] }}</template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>